import React from "react";
import ApproveButton from "@components/FlowActionButtons/ApproveButton";
import ClaimButton from "@components/FlowActionButtons/ClaimButton";
import RejectButton from "@components/FlowActionButtons/RejectButton";
import UnclaimButton from "@components/FlowActionButtons/UnclaimButton";
import UpdateButton from "@components/FlowActionButtons/UpdateButton";
import { getTerminalServiceFlowActionAvailability, type TerminalServiceFlowData } from "./utils";

const LANG_BASE = "terminal-services.details";

interface TerminalServiceFlowButtonsProps {
  terminalServiceFlowData?: TerminalServiceFlowData;
  onClaim: () => void;
  onUnclaim: () => void;
  onApprove: () => void;
  onReject: () => void;
  onUpdate: () => void;
}

const TerminalServiceFlowButtons: React.FC<TerminalServiceFlowButtonsProps> = ({
  terminalServiceFlowData,
  onClaim,
  onUnclaim,
  onApprove,
  onReject,
  onUpdate,
}) => {
  const task = terminalServiceFlowData?.task;

  if (!terminalServiceFlowData || !task) {
    return null;
  }

  const actionAvailability = getTerminalServiceFlowActionAvailability({
    taskStatus: task.status,
    claimOwnerName: task.claimOwnerName,
    status: terminalServiceFlowData.status,
  });

  return (
    <div className="flex flex-wrap justify-end gap-4">
      <UnclaimButton
        langBase={LANG_BASE}
        permission="canUnclaimFottService"
        isActionAvailable={actionAvailability.canUnclaim}
        onUnclaim={onUnclaim}
      />
      <RejectButton
        langBase={LANG_BASE}
        permission="canApproveFottService"
        isActionAvailable={actionAvailability.canReject}
        onReject={onReject}
      />
      <ApproveButton
        langBase={LANG_BASE}
        permission="canApproveFottService"
        isActionAvailable={actionAvailability.canApprove}
        onApprove={onApprove}
      />
      <ClaimButton
        langBase={LANG_BASE}
        permission="canClaimFottService"
        isActionAvailable={actionAvailability.canClaim}
        onClaim={onClaim}
      />
      <UpdateButton
        langBase={LANG_BASE}
        permission="canUpdateFottService"
        isActionAvailable={actionAvailability.canUpdate}
        onUpdate={onUpdate}
      />
    </div>
  );
};

export default TerminalServiceFlowButtons;
